export interface ModalCloseResult<R = unknown> {
  clearNotifications?: boolean;
  reason?: R;
}
